import script from "./CatalogueControl.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogueControl.vue?vue&type=script&setup=true&lang=js"

import "./CatalogueControl.vue?vue&type=style&index=0&id=059541f4&lang=css"

const __exports__ = script;

export default __exports__